/**
 * Channel annotations API calls
 */

import apiClient from './client';
import {
  ChatWithAnnotation,
  ChannelAnnotation,
  ChannelAnnotationUpdate,
  ChatFileStatsResponse,
} from '@/types/api';

/**
 * The endpoint defaults to manuscript channels only. The param must be sent
 * explicitly, otherwise every caller is silently locked to that subset.
 */
export const getChatsWithAnnotations = async (
  manuscriptOnly: boolean
): Promise<ChatWithAnnotation[]> => {
  const response = await apiClient.get<ChatWithAnnotation[]>(
    '/channel-annotations/chats-with-annotations',
    { params: { manuscript_only: manuscriptOnly } }
  );
  return response.data;
};

export const updateChannelAnnotation = async (
  chatId: number,
  data: ChannelAnnotationUpdate
): Promise<ChannelAnnotation> => {
  const response = await apiClient.put<ChannelAnnotation>(
    `/channel-annotations/${chatId}`,
    data
  );
  return response.data;
};

export const deleteChannelAnnotation = async (chatId: number): Promise<void> => {
  await apiClient.delete(`/channel-annotations/${chatId}`);
};

export const getChatFileStats = async (chatId: number): Promise<ChatFileStatsResponse> => {
  const response = await apiClient.get<ChatFileStatsResponse>(
    `/channel-annotations/${chatId}/file-stats`
  );
  return response.data;
};
